module.exports = __webpack_public_path__ + "static/img/slide2_w.24b41b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide2_w.jpeg
// module id = SMeu
// module chunks = 1